if (!customElements.get('scrolling-text')) {
  customElements.define('scrolling-text', class ScrollingText extends HTMLElement {
    constructor() {
      super();
      this.isTouch = false;
    }

    connectedCallback() {
      this.stop = Motion.inView(this, (info) => {
        this.#duplicateItems();
        this.runAnimation();
      });

      // Wykryj czy użytkownik używa dotyku
      this.addEventListener('touchstart', this.#handleTouchStart.bind(this), { passive: true });
      
      // Zapobiegaj zatrzymywaniu animacji na mobile przy touch
      if (this.classList.contains('scrolling-text__content--pause-on-hover')) {
        this.#preventTouchPause();
      }
    }

    disconnectedCallback() {
      if(this.stop) {
        this.stop();
      }
      this.removeEventListener('touchstart', this.#handleTouchStart);
    }

    #handleTouchStart() {
      this.isTouch = true;
    }

    #preventTouchPause() {
      // Dodaj klasę tylko dla prawdziwego hover (nie touch)
      this.addEventListener('mouseenter', (e) => {
        if (!this.isTouch) {
          this.classList.add('is-paused');
        }
      });

      this.addEventListener('mouseleave', (e) => {
        if (!this.isTouch) {
          this.classList.remove('is-paused');
        }
      });

      // Upewnij się, że touch nie zatrzymuje animacji
      this.addEventListener('touchstart', () => {
        this.classList.remove('is-paused');
      }, { passive: true });
    }

    runAnimation() {
      setTimeout(() => {
        this.classList.add('enable-animation');
      }, 500);
    }

    #duplicateItems() {
      // POPRAWKA: Szukaj .scrolling-text__item zamiast .scrolling-text__li
      const items = this.querySelectorAll('.scrolling-text__list--original .scrolling-text__item');
      if(items.length > 0) {
        const repeatedList = this.querySelector('.scrolling-text__list--repeated');
        items.forEach(item => {
          repeatedList.appendChild(this.#cloneItem(item));
        });
        if(items.length == 1) {
          this.querySelector('.scrolling-text__list--original').appendChild(this.#cloneItem(items[0]));
          repeatedList.appendChild(this.#cloneItem(items[0]));
        }
      }
    }

    #cloneItem(item) {
      const clonedItem = item.cloneNode(true);
      if(Shopify.designMode) {
        clonedItem.removeAttribute('data-shopify-editor-block');
      }
      return clonedItem;
    }
  });
}